(function () {
  function parseVariants() {
    var el = document.getElementById('jeep-kit-bundle-variants');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function findBundleVariantId(variants, modelLabel) {
    if (!modelLabel || !variants.length) return null;
    var normalized = String(modelLabel).trim().toLowerCase();

    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var options = [variant.option1, variant.option2, variant.option3].filter(Boolean);
      for (var j = 0; j < options.length; j++) {
        if (String(options[j]).trim().toLowerCase() === normalized) {
          return variant.id;
        }
      }
      if (variant.title && String(variant.title).toLowerCase().indexOf(normalized) !== -1) {
        return variant.id;
      }
    }

    return null;
  }

  function initUpsell(root) {
    var link = root.querySelector('[data-jeep-kit-upsell-link]');
    var note = root.querySelector('[data-jeep-kit-upsell-note]');
    if (!link) return;

    var baseUrl = link.getAttribute('href').split('?')[0];
    var variants = parseVariants();

    function updateLink(detail) {
      var url = baseUrl;
      var variantId = null;

      if (detail && detail.model) {
        variantId = findBundleVariantId(variants, detail.model);
      }

      if (!variantId && detail && detail.modelVariantId && window.UTSI) {
        var suffix = document.getElementById('product-single');
        suffix = suffix && suffix.getAttribute('data-template-suffix');
        if (suffix === 'inserts-single' && detail.modelVariantId) {
          variantId = detail.modelVariantId;
        }
      }

      if (variantId) {
        url += '?variant=' + variantId;
        if (note) note.hidden = false;
      } else if (note) {
        note.hidden = true;
      }

      link.setAttribute('href', url);
    }

    if (window.UTSI && typeof UTSI.getPdpSelections === 'function') {
      updateLink(UTSI.getPdpSelections());
    }

    document.addEventListener('utsi:pdp-selection-change', function (event) {
      updateLink(event.detail);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var upsells = document.querySelectorAll('[data-jeep-kit-upsell]');
    upsells.forEach(initUpsell);
  });
})();
